import React from "react";
import { useEffect, useState } from "react";
import { collection, getDocs } from "firebase/firestore";
import { CreateData } from "../firebase Component/CreateData";
import { db } from "../firebase Component/firebase-config";
import UpdateData from "../firebase Component/UpdateData";
function MsgBox(props) {
  return (
    <div>
      <h1 className="title-font sm:text-3xl text-2xl mb-4 font-poppinsBold text-cusOrange  ali">
        {props.name}
      </h1>

      <h1 className="title-font sm:text-4xl text-3xl mb-4 font-poppinsBold text-cusOrange  ali">
        {props.title}
      </h1>

      <div className="invisible"></div>
      <h1 className="title-font sm:text-xl text-lg m-24 font-poppinsLight text-gray-900 ali">
        {props.message}
      </h1>
    </div>
  );
}

const MsgRendering = ({ message, title, name, date, Id, read, collection }) => {
  const [Read, setRead] = useState(read);

  return (
    <div className="text-center lg:w-2/3 w-auto h-full">
      <MsgBox message={message} title={title} name={name} />
      <div>
        <button
          class="mx-auto mb-10 mt-10 bg-cusOrange text-white bg-yellow-500 border-0 py-2 px-8 focus:outline-none hover:bg-yellow-600 rounded text-lg"
          onClick={() => {
            UpdateData(Id, { read: !Read }, collection);
            setRead(!Read);
          }}
        >
          Read {Read ? "✔️" : null}
        </button>
        <h2 className="title-font sm:text-2xl text-1xl mb-4 font-poppinsBold text-cusOrange font-light">
          {date}
        </h2>
      </div>
      <div class="p-2 w-full pt-8 mt-8 border-t border-cusOrange text-center"></div>
    </div>
  );
};
function sort_by_number() {
  return function (elem1, elem2) {
    if (elem1.number < elem2.number) {
      return -1;
    } else if (elem1.number > elem2.number) {
      return 1;
    } else {
      return 0;
    }
  };
}

function RestorePage() {
  const CollectionName = "Msg";
  const [Data, setData] = useState([]);
  const dataRef = collection(db, String(CollectionName));
  const [index , setIndex] = useState(null);
  const DataFetching = async () => {
    const data = await getDocs(dataRef);
    
     const ArrData = data.docs.map((recData) => ({ ...recData.data(), id: recData.id }))
     setIndex(ArrData.length+1)
    const Arr =ArrData.filter((num)=> num.read === true)
     Arr.sort(sort_by_number())
     setData(Arr)
    
  };

  // eslint-disable-next-line
  useEffect(() => {
    DataFetching();

    // eslint-disable-next-line
  }, []);


  const [formData, setFormData] = useState({
    name: "",
    title: "",
    msg: "",
  });

  const HandleChange = (name, data) => {
    setFormData({ ...formData, [name]: data });
  };

  const SendData = () => {
    var today = new Date();
    var date =
      today.getFullYear() +
      "-" +
      (today.getMonth() + 1) +
      "-" +
      today.getDate();
    var time =
      today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds();
    var dateTime = date + " at " + time;
    var TransmitDataValue = {
      name: formData.name,
      title: formData.title,
      msg: formData.msg,
      date: dateTime,
      read: false,
      number: index,
    };
    TransmitData(TransmitDataValue);
  };
  const TransmitData = (newData) => {
    CreateData(CollectionName, newData);

    alert("Msg submited Successfully");
    setTimeout(() => {
      window.location.reload();
    }, 3000);
  };

  return (
    <div className="container  mx-auto flex px-0 py-0 pt-3 items-center  justify-center flex-col">
      {Data &&
        Data.map((data, index) => {
          return (
            <MsgRendering
              message={data.msg}
              title={data.title}
              key={index}
              name={data.name}
              Id={data.id}
              date={data.date}
              read={data.read}
              collection={CollectionName}
            />
          );
        })}
      <section class="text-gray-600 body-font relative">
        <div class="container px-5 py-24 mx-auto">
          <div class="flex flex-col text-center w-full mb-12">
            <h1 class="sm:text-3xl text-2xl font-medium title-font mb-4 text-gray-900">
              Write your Msg Here
            </h1>
          </div>
          <div class="lg:w-1/2 md:w-2/3 mx-auto">
            <div class="flex flex-wrap -m-2">
              <div class="p-2 w-1/2">
                <div class="relative">
                  <label for="name" class="leading-7 text-sm text-gray-600">
                    Name
                  </label>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    class="w-full bg-gray-100 bg-opacity-50  rounded border border-gray-300 focus:border-yellow-500 focus:bg-white focus:ring-2 focus:ring-yellow-200 text-base outline-none text-cusLightBlack py-1 px-3 leading-8 transition-colors duration-200 ease-in-out"
                    onChange={(e) => {
                      HandleChange("name", e.target.value);
                    }}
                  />
                </div>
              </div>
              <div class="p-2 w-1/2">
                <div class="relative">
                  <label for="email" class="leading-7 text-sm text-gray-600">
                    Title
                  </label>
                  <input
                    type="text"
                    id="email"
                    name="email"
                    class="w-full bg-gray-100 bg-opacity-50 rounded border border-gray-300 focus:border-yellow-500 focus:bg-white focus:ring-2 focus:ring-yellow-200 text-base outline-none text-cusLightBlack py-1 px-3 leading-8 transition-colors duration-200 ease-in-out"
                    onChange={(e) => {
                      HandleChange("title", e.target.value);
                    }}
                  />
                </div>
              </div>
              <div class="p-2 w-full">
                <div class="relative">
                  <label for="message" class="leading-7 text-sm text-gray-600">
                    Message
                  </label>
                  <textarea
                    id="message"
                    name="message"
                    class="w-full bg-gray-100 bg-opacity-50 text-cusLightBlack rounded border border-gray-300 focus:border-yellow-500 focus:bg-white focus:ring-2 focus:ring-yellow-200 h-32 text-base outline-none text-gray-700 py-1 px-3 resize-none leading-6 transition-colors duration-200 ease-in-out"
                    onChange={(e) => {
                      HandleChange("msg", e.target.value);
                    }}
                  ></textarea>
                </div>
              </div>
              <div class="p-2 w-full">
                <button
                  class="flex mx-auto bg-cusOrange text-white bg-yellow-500 border-0 py-2 px-8 focus:outline-none hover:bg-yellow-600 rounded text-lg"
                  onClick={() => {
                    SendData();
                  }}
                >
                  Send
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default RestorePage;
